export interface SubCategory {
  id: string;
  name: string;
  icon: string;
  providerCount: number;
}

export interface Category {
  id: string;
  name: string;
  description: string;
  icon: string;
  image: string;
  color: string;
  providerCount: number;
  subCategories: SubCategory[];
}

export const categories: Category[] = [
  {
    id: "construction",
    name: "Construction & Repairs",
    description: "Building, renovation, and home repair services",
    icon: "🏗️",
    image: "/images/categories/construction.jpg",
    color: "bg-orange-500",
    providerCount: 7200,
    subCategories: [
      { id: "plumbing", name: "Plumbing", icon: "🔧", providerCount: 580 },
      { id: "electrical", name: "Electrical Installation", icon: "⚡", providerCount: 620 },
      { id: "tiling", name: "Tiling & Flooring", icon: "🧱", providerCount: 390 },
      { id: "flooring", name: "Flooring Installation", icon: "🏠", providerCount: 280 },
      { id: "roofing", name: "Roofing & Ceiling", icon: "🏠", providerCount: 280 },
      { id: "roofers", name: "Roofers", icon: "🏠", providerCount: 220 },
      { id: "painting", name: "Painting & Decoration", icon: "🎨", providerCount: 450 },
      { id: "carpentry", name: "Carpentry & Woodwork", icon: "🪚", providerCount: 380 },
      { id: "masonry", name: "Masonry & Bricklaying", icon: "🧱", providerCount: 320 },
      { id: "bricklayer", name: "Bricklayer", icon: "🧱", providerCount: 280 },
      { id: "welding", name: "Welding & Fabrication", icon: "🔥", providerCount: 430 },
      { id: "millwright", name: "Millwright", icon: "⚙️", providerCount: 120 },
      { id: "rigger", name: "Rigger", icon: "🔗", providerCount: 90 },
      { id: "crane-operator", name: "Crane Operator", icon: "🏗️", providerCount: 80 },
      { id: "metal-fabricators", name: "Metal Work Fabricators", icon: "🔩", providerCount: 320 },
      { id: "pop-screeding", name: "POP & Screeding", icon: "🏢", providerCount: 290 },
      { id: "aluminum", name: "Aluminum & Glass Works", icon: "🪟", providerCount: 280 },
      { id: "window-door-framing", name: "Window & Door Framing", icon: "🚪", providerCount: 240 },
      { id: "interlocking", name: "Interlocking Stones", icon: "🧱", providerCount: 180 },
      { id: "demolition", name: "Demolition Services", icon: "🏚️", providerCount: 120 },
      { id: "scaffolding", name: "Scaffolding Services", icon: "🪜", providerCount: 150 },
      { id: "waterproofing", name: "Waterproofing", icon: "💧", providerCount: 140 },
      { id: "gutter-installation", name: "Gutter Installation", icon: "🌧️", providerCount: 120 },
      { id: "fence-erection", name: "Fence & Gate Erection", icon: "🚧", providerCount: 120 },
      { id: "solar-installers", name: "Solar Installers", icon: "☀️", providerCount: 280 },
      { id: "architect", name: "Architect", icon: "📐", providerCount: 180 },
      { id: "estimator", name: "Estimator", icon: "📊", providerCount: 120 },
      { id: "inspectors", name: "Building Inspectors", icon: "🔍", providerCount: 90 },
      { id: "structural-cabling", name: "Structural Cabling", icon: "🔌", providerCount: 150 },
      { id: "carpet-floor-covering-installer", name: "Carpet & Floor Covering Installer", icon: "🧶", providerCount: 120 },
      { id: "glazier", name: "Glazier", icon: "🪟", providerCount: 120 },
      { id: "insulator", name: "Insulator", icon: "🧊", providerCount: 120 },
      { id: "lather", name: "Lather (Lathing)", icon: "🪚", providerCount: 120 },
      { id: "tile-setter", name: "Tile Setter", icon: "🔲", providerCount: 120 },
      { id: "sprinkler-system-installer", name: "Sprinkler System Installer", icon: "💦", providerCount: 120 },
      { id: "iron-worker", name: "Iron Worker", icon: "⛓️", providerCount: 120 },
      { id: "water-well-driller", name: "Water Well Driller", icon: "🕳️", providerCount: 120 },
      { id: "borehole-driller", name: "Borehole Driller & Installer", icon: "🚰", providerCount: 120 },
      { id: "concrete-finisher", name: "Concrete Specialist & Finisher", icon: "🧱", providerCount: 120 },
      { id: "deck-contractor", name: "Deck Contractor", icon: "🪵", providerCount: 120 },
      { id: "door-installer", name: "Door Installer", icon: "🚪", providerCount: 120 },
      { id: "drywall-installer", name: "Drywall Installer", icon: "🧱", providerCount: 120 },
      { id: "excavation", name: "Excavation", icon: "⛏️", providerCount: 120 },
      { id: "foundation-repair", name: "Foundation Repair", icon: "🏚️", providerCount: 120 },
      { id: "basement-waterproofing", name: "Basement Waterproofing Specialist", icon: "💧", providerCount: 120 },
      { id: "bathroom-renovation", name: "Bathroom Renovation", icon: "🛁", providerCount: 120 },
      { id: "garage-door", name: "Garage Door Installation & Repair", icon: "🚗", providerCount: 120 },
      { id: "general-contractor", name: "General Contractor", icon: "📋", providerCount: 120 },
      { id: "gutter-cleaning", name: "Gutter Cleaning", icon: "🧹", providerCount: 120 },
      { id: "gutters-eavestroughs", name: "Gutters & Eavestroughs", icon: "🌧️", providerCount: 120 },
      { id: "plasterer", name: "Plasterer", icon: "🪣", providerCount: 120 },
      { id: "epoxy-flooring", name: "Epoxy Flooring", icon: "✨", providerCount: 120 },
      { id: "cabinet-maker", name: "Cabinet Maker", icon: "🗄️", providerCount: 120 },
      { id: "home-inspector", name: "Home Inspector", icon: "🔎", providerCount: 120 },
    ],
  },
  {
    id: "handyman",
    name: "General Handyman",
    description: "Multi-skilled professionals for everyday repairs and fixes",
    icon: "🛠️",
    image: "/images/categories/handyman.jpg",
    color: "bg-yellow-600",
    providerCount: 4500,
    subCategories: [
      { id: "general-repairs", name: "General Home Repairs", icon: "🔨", providerCount: 480 },
      { id: "furniture-assembly", name: "Furniture Assembly", icon: "🪑", providerCount: 320 },
      { id: "door-repairs", name: "Door & Lock Repairs", icon: "🚪", providerCount: 280 },
      { id: "locksmith", name: "Locksmith", icon: "🔐", providerCount: 220 },
      { id: "window-repairs", name: "Window Repairs", icon: "🪟", providerCount: 220 },
      { id: "ceiling-fan", name: "Ceiling Fan Installation", icon: "🌀", providerCount: 260 },
      { id: "tv-mounting", name: "TV Mounting", icon: "📺", providerCount: 190 },
      { id: "audio-tv-installer", name: "Audio & TV Installer", icon: "🔊", providerCount: 180 },
      { id: "shelf-installation", name: "Shelf Installation", icon: "📚", providerCount: 180 },
      { id: "curtain-blinds", name: "Curtain & Blinds Install", icon: "🪟", providerCount: 220 },
      { id: "curtain-rail", name: "Curtain & Rail", icon: "🪟", providerCount: 180 },
      { id: "general-mounting", name: "General Mounting", icon: "🔩", providerCount: 200 },
      { id: "minor-electrical", name: "Minor Electrical Fixes", icon: "💡", providerCount: 290 },
      { id: "minor-plumbing", name: "Minor Plumbing Fixes", icon: "🚿", providerCount: 260 },
      { id: "appliance-install", name: "Appliance Installation", icon: "🔌", providerCount: 240 },
      { id: "picture-hanging", name: "Picture & Mirror Hanging", icon: "🖼️", providerCount: 160 },
      { id: "weather-stripping", name: "Weather Stripping", icon: "🌡️", providerCount: 100 },
      { id: "baby-proofing", name: "Baby Proofing", icon: "👶", providerCount: 120 },
      { id: "lighting-installation", name: "Lighting Installation", icon: "💡", providerCount: 220 },
    ],
  },
  {
    id: "appliance-repair",
    name: "Appliance Repair",
    description: "Fixing and servicing home and office appliances",
    icon: "🔌",
    image: "/images/categories/appliance.jpg",
    color: "bg-cyan-600",
    providerCount: 2800,
    subCategories: [
      { id: "ac-repair", name: "AC Repair & Service", icon: "❄️", providerCount: 380 },
      { id: "hvac", name: "HVAC Services", icon: "🌡️", providerCount: 280 },
      { id: "refrigerator", name: "Refrigerator Repair", icon: "🧊", providerCount: 290 },
      { id: "washing-machine", name: "Washing Machine Repair", icon: "🧺", providerCount: 240 },
      { id: "generator-repair", name: "Generator Repair", icon: "⚡", providerCount: 320 },
      { id: "inverter-solar", name: "Inverter & Solar Systems", icon: "☀️", providerCount: 280 },
      { id: "inverters-stabilizer", name: "Inverters & Stabilizer", icon: "🔋", providerCount: 200 },
      { id: "microwave", name: "Microwave & Oven Repair", icon: "📡", providerCount: 140 },
      { id: "water-heater", name: "Water Heater Repair", icon: "🚿", providerCount: 160 },
      { id: "blender-mixer", name: "Blender & Mixer Repair", icon: "🥤", providerCount: 120 },
      { id: "tv-repair", name: "TV & Electronics Repair", icon: "📺", providerCount: 170 },
      { id: "dryer-repair", name: "Dryer Repair", icon: "🌀", providerCount: 120 },
      { id: "furnace-services", name: "Furnace Services", icon: "🔥", providerCount: 120 },
      { id: "boiler-repair", name: "Boiler Repair", icon: "♨️", providerCount: 120 },
      { id: "air-duct-cleaning", name: "Air Duct Cleaning Services", icon: "🌬️", providerCount: 120 },
      { id: "refrigeration-ac-mechanic", name: "Refrigeration & AC Mechanic", icon: "❄️", providerCount: 120 },
      { id: "appliance-service-tech", name: "Appliance Service Technician", icon: "🔧", providerCount: 120 },
      { id: "home-electronics", name: "Home Electronics Installation", icon: "📻", providerCount: 120 },
      { id: "video-wall", name: "Video Wall Installation", icon: "🖥️", providerCount: 120 },
      { id: "gym-equipment-tech", name: "Gym Equipment Technician", icon: "🏋️", providerCount: 120 },
    ],
  },
  {
    id: "automotive",
    name: "Automotive Services",
    description: "Vehicle repairs, maintenance, and customization",
    icon: "🚗",
    image: "/images/categories/automotive.jpg",
    color: "bg-blue-600",
    providerCount: 3800,
    subCategories: [
      { id: "mechanic", name: "Auto Mechanics", icon: "🔧", providerCount: 550 },
      { id: "heavy-duty-mechanic", name: "Heavy Duty Mechanic", icon: "🚛", providerCount: 180 },
      { id: "diesel-mechanic", name: "Diesel Mechanic", icon: "⛽", providerCount: 160 },
      { id: "panel-beating", name: "Panel Beating", icon: "🚙", providerCount: 280 },
      { id: "auto-electrical", name: "Auto Electrician", icon: "🔌", providerCount: 320 },
      { id: "vulcanizer", name: "Vulcanizer & Tyre Services", icon: "🛞", providerCount: 440 },
      { id: "car-wash", name: "Car Wash & Detailing", icon: "🧽", providerCount: 380 },
      { id: "car-ac-repair", name: "Car AC Repair", icon: "❄️", providerCount: 190 },
      { id: "towing", name: "Towing Services", icon: "🚛", providerCount: 120 },
      { id: "spray-painting", name: "Spray Painting", icon: "🎨", providerCount: 210 },
      { id: "upholstery", name: "Auto Upholstery", icon: "🪑", providerCount: 140 },
      { id: "motorcycle-repair", name: "Motorcycle Repair", icon: "🏍️", providerCount: 180 },
      { id: "forklift-technician", name: "Forklift Technician", icon: "🏗️", providerCount: 90 },
      { id: "battery-service", name: "Battery & Charging", icon: "🔋", providerCount: 80 },
      { id: "auto-body-technician", name: "Auto Body Technician", icon: "🚙", providerCount: 120 },
      { id: "automotive-service-technician", name: "Automotive Service Technician", icon: "🔧", providerCount: 120 },
      { id: "agricultural-equipment-tech", name: "Agricultural Equipment Technician", icon: "🚜", providerCount: 120 },
      { id: "heavy-equipment-tech", name: "Heavy Equipment Technician", icon: "🚛", providerCount: 120 },
      { id: "parts-technician", name: "Parts Technician", icon: "⚙️", providerCount: 120 },
      { id: "recreation-equipment-services", name: "Recreation Equipment Services", icon: "🛶", providerCount: 120 },
      { id: "bicycle-repair-tech", name: "Bicycle Repair Technician", icon: "🚲", providerCount: 120 },
    ],
  },
  {
    id: "ict",
    name: "ICT & Digital Skills",
    description: "Technology, software, and digital services",
    icon: "💻",
    image: "/images/categories/ict.jpg",
    color: "bg-purple-600",
    providerCount: 1950,
    subCategories: [
      { id: "web-dev", name: "Web Development", icon: "🌐", providerCount: 280 },
      { id: "mobile-dev", name: "Mobile App Development", icon: "📱", providerCount: 190 },
      { id: "computer-repair", name: "Computer Repair", icon: "🖥️", providerCount: 440 },
      { id: "phone-repair", name: "Phone Repair", icon: "📱", providerCount: 380 },
      { id: "networking", name: "Networking & CCTV", icon: "📡", providerCount: 220 },
      { id: "graphics", name: "Graphics Design", icon: "🎨", providerCount: 310 },
      { id: "data-entry", name: "Data Entry & Admin", icon: "📊", providerCount: 180 },
      { id: "seo", name: "SEO & Digital Marketing", icon: "📈", providerCount: 130 },
      { id: "it-support", name: "Information Tech Support", icon: "💻", providerCount: 240 },
      { id: "telecomms-technician", name: "Telecomms Technician", icon: "📡", providerCount: 180 },
      { id: "printer-repair", name: "Printer Repair", icon: "🖨️", providerCount: 120 },
    ],
  },
  {
    id: "creative",
    name: "Creative & Media",
    description: "Photography, videography, and creative arts",
    icon: "🎬",
    image: "/images/categories/creative.jpg",
    color: "bg-pink-500",
    providerCount: 2400,
    subCategories: [
      { id: "photography", name: "Photography", icon: "📸", providerCount: 380 },
      { id: "videography", name: "Videography", icon: "🎥", providerCount: 220 },
      { id: "music", name: "Music & DJ Services", icon: "🎵", providerCount: 290 },
      { id: "dancers", name: "Dancers", icon: "💃", providerCount: 180 },
      { id: "songwriters", name: "Songwriters", icon: "🎶", providerCount: 120 },
      { id: "comedy", name: "Comedy", icon: "😂", providerCount: 110 },
      { id: "emcee", name: "Emcee / Host", icon: "🎤", providerCount: 140 },
      { id: "event-planning", name: "Event Planning", icon: "🎉", providerCount: 180 },
      { id: "makeup-artist", name: "Makeup Artist", icon: "💄", providerCount: 320 },
      { id: "fashion", name: "Fashion Design", icon: "👗", providerCount: 210 },
      { id: "interior-design", name: "Interior Design", icon: "🛋️", providerCount: 100 },
      { id: "decorators", name: "Decorators (Weddings, Events)", icon: "🎀", providerCount: 280 },
      { id: "tattoo", name: "Tattoo Artist", icon: "🎨", providerCount: 120 },
    ],
  },
  {
    id: "domestic",
    name: "Domestic Services",
    description: "Home cleaning, childcare, and household help",
    icon: "🏠",
    image: "/images/categories/domestic.jpg",
    color: "bg-teal-500",
    providerCount: 4200,
    subCategories: [
      { id: "cleaning", name: "Home Cleaning", icon: "🧹", providerCount: 580 },
      { id: "laundry", name: "Laundry & Dry Cleaning", icon: "👕", providerCount: 390 },
      { id: "cooking", name: "Cooking & Catering", icon: "👨‍🍳", providerCount: 440 },
      { id: "cook", name: "Personal Cook", icon: "🍳", providerCount: 280 },
      { id: "baking", name: "Baking", icon: "🧁", providerCount: 220 },
      { id: "childcare", name: "Childcare & Nanny", icon: "👶", providerCount: 320 },
      { id: "elderly-care", name: "Elderly Care", icon: "👵", providerCount: 180 },
      { id: "caregiver", name: "Caregiver", icon: "❤️", providerCount: 200 },
      { id: "gardening", name: "Gardening & Landscaping", icon: "🌱", providerCount: 290 },
      { id: "lawn-mower", name: "Lawn Mower", icon: "🌿", providerCount: 180 },
      { id: "pest-control", name: "Pest Control", icon: "🐜", providerCount: 200 },
      { id: "fumigation", name: "Fumigation", icon: "💨", providerCount: 200 },
      { id: "home-moving", name: "Home Moving", icon: "📦", providerCount: 280 },
      { id: "helpers-assistant", name: "Helpers & Assistants", icon: "🙋", providerCount: 340 },
      { id: "errand-person", name: "Errand Person", icon: "🏃", providerCount: 260 },
      { id: "pet-services", name: "Pet Services", icon: "🐕", providerCount: 180 },
      { id: "carpet-cleaner", name: "Carpet Cleaner", icon: "🧽", providerCount: 120 },
      { id: "industrial-cleaning", name: "Industrial Cleaning", icon: "🏭", providerCount: 120 },
      { id: "drain-cleaning", name: "Drain Cleaning", icon: "🚽", providerCount: 120 },
      { id: "upholstery", name: "Upholstery", icon: "🛋️", providerCount: 120 },
      { id: "furniture-maker", name: "Furniture Maker", icon: "🪑", providerCount: 120 },
    ],
  },
  {
    id: "tailoring",
    name: "Tailoring & Fashion",
    description: "Custom clothing, alterations, and fashion services",
    icon: "🧵",
    image: "/images/categories/tailoring.jpg",
    color: "bg-rose-500",
    providerCount: 1450,
    subCategories: [
      { id: "mens-tailoring", name: "Men's Tailoring", icon: "👔", providerCount: 320 },
      { id: "womens-tailoring", name: "Women's Tailoring", icon: "👗", providerCount: 380 },
      { id: "alterations", name: "Alterations & Repairs", icon: "✂️", providerCount: 280 },
      { id: "aso-ebi", name: "Aso Ebi & Traditional", icon: "🎭", providerCount: 220 },
      { id: "embroidery", name: "Embroidery", icon: "🧶", providerCount: 130 },
      { id: "shoe-making", name: "Shoe Making & Repair", icon: "👞", providerCount: 120 },
    ],
  },
  {
    id: "health",
    name: "Health & Wellness",
    description: "Fitness, beauty, spa, and non-clinical wellness",
    icon: "💆",
    image: "/images/categories/health.jpg",
    color: "bg-green-500",
    providerCount: 2200,
    subCategories: [
      { id: "fitness", name: "Fitness Training", icon: "💪", providerCount: 280 },
      { id: "spa", name: "Spa Services", icon: "💆", providerCount: 220 },
      { id: "massage-therapy", name: "Massage Therapy", icon: "💆‍♀️", providerCount: 280 },
      { id: "salon-spa", name: "Salon & Spa", icon: "💇‍♀️", providerCount: 320 },
      { id: "hair", name: "Hair Styling", icon: "💇", providerCount: 380 },
      { id: "barbing", name: "Barbing & Grooming", icon: "✂️", providerCount: 280 },
      { id: "manicure", name: "Manicure & Pedicure", icon: "💅", providerCount: 120 },
    ],
  },
  {
    id: "education",
    name: "Education & Training",
    description: "Tutoring, lessons, and skill development",
    icon: "📚",
    image: "/images/categories/education.jpg",
    color: "bg-indigo-500",
    providerCount: 1540,
    subCategories: [
      { id: "tutoring", name: "Academic Tutoring", icon: "📖", providerCount: 480 },
      { id: "music-lessons", name: "Music Lessons", icon: "🎹", providerCount: 140 },
      { id: "driving", name: "Driving School", icon: "🚗", providerCount: 280 },
      { id: "language", name: "Language Training", icon: "🗣️", providerCount: 180 },
      { id: "vocational", name: "Vocational Training", icon: "🛠️", providerCount: 320 },
      { id: "computer-training", name: "Computer Training", icon: "💻", providerCount: 140 },
    ],
  },
  {
    id: "agriculture",
    name: "Agriculture & Technical",
    description: "Farming, equipment, and technical services",
    icon: "🌾",
    image: "/images/categories/agriculture.jpg",
    color: "bg-amber-600",
    providerCount: 1450,
    subCategories: [
      { id: "farming", name: "Farming Consultancy", icon: "🚜", providerCount: 180 },
      { id: "farm-workers", name: "Farm Workers", icon: "👨‍🌾", providerCount: 220 },
      { id: "farm-hands", name: "Farm Hands", icon: "🌱", providerCount: 180 },
      { id: "crop-harvester", name: "Crop Harvester", icon: "🌾", providerCount: 120 },
      { id: "livestock", name: "Livestock Services", icon: "🐄", providerCount: 150 },
      { id: "poultry", name: "Poultry Services", icon: "🐔", providerCount: 140 },
      { id: "fishery", name: "Fishery & Aquaculture", icon: "🐟", providerCount: 120 },
      { id: "agro-processing", name: "Agro Processing", icon: "🏭", providerCount: 100 },
      { id: "irrigation", name: "Irrigation Systems", icon: "💧", providerCount: 90 },
      { id: "equipment", name: "Equipment Repair", icon: "🔧", providerCount: 110 },
      { id: "tractor-operators", name: "Tractor Operators", icon: "🚜", providerCount: 80 },
      { id: "veterinary", name: "Veterinary Services", icon: "🐕", providerCount: 100 },
    ],
  },
  {
    id: "logistics",
    name: "Logistics & Delivery",
    description: "Moving, transportation, and courier services",
    icon: "🚚",
    image: "/images/categories/logistics.jpg",
    color: "bg-red-500",
    providerCount: 960,
    subCategories: [
      { id: "moving", name: "Moving & Relocation", icon: "📦", providerCount: 240 },
      { id: "courier", name: "Courier Services", icon: "📮", providerCount: 280 },
      { id: "trucking", name: "Trucking & Haulage", icon: "🚛", providerCount: 180 },
      { id: "dispatch", name: "Dispatch Riders", icon: "🏍️", providerCount: 260 },
      { id: "drivers", name: "Drivers", icon: "🚗", providerCount: 380 },
      { id: "chauffeur", name: "Chauffeur & Personal Driver", icon: "🚘", providerCount: 160 },
      { id: "bus-driver", name: "Bus Driver", icon: "🚌", providerCount: 140 },
      { id: "truck-driver", name: "Truck Driver", icon: "🚚", providerCount: 220 },
      { id: "forklift-driver", name: "Forklift Driver", icon: "🚜", providerCount: 90 },
      { id: "ride-share-driver", name: "Ride-Share Driver", icon: "🚕", providerCount: 180 },
    ],
  },
  {
    id: "security",
    name: "Security Services",
    description: "Security personnel, systems, and safety services",
    icon: "🛡️",
    image: "/images/categories/security.jpg",
    color: "bg-gray-700",
    providerCount: 680,
    subCategories: [
      { id: "security-guard", name: "Security Guards", icon: "👮", providerCount: 280 },
      { id: "cctv-install", name: "CCTV Installation", icon: "📹", providerCount: 180 },
      { id: "alarm-systems", name: "Alarm Systems", icon: "🚨", providerCount: 120 },
      { id: "access-control", name: "Access Control", icon: "🔐", providerCount: 100 },
    ],
  },
  {
    id: "legal-finance",
    name: "Legal & Financial",
    description: "Accounting, legal, and business services",
    icon: "⚖️",
    image: "/images/categories/legal.jpg",
    color: "bg-slate-600",
    providerCount: 680,
    subCategories: [
      { id: "accounting", name: "Accounting & Bookkeeping", icon: "📊", providerCount: 220 },
      { id: "accounting-technician", name: "Accounting Technician", icon: "🧮", providerCount: 160 },
      { id: "tax", name: "Tax Services", icon: "📋", providerCount: 140 },
      { id: "legal", name: "Legal Services", icon: "⚖️", providerCount: 170 },
      { id: "notary", name: "Notary Services", icon: "📝", providerCount: 80 },
      { id: "insurance", name: "Insurance Agents", icon: "🛡️", providerCount: 70 },
    ],
  },
  {
    id: "events-hospitality",
    name: "Events & Hospitality",
    description: "Event staffing, catering, and hospitality services",
    icon: "🎉",
    image: "/images/categories/events.jpg",
    color: "bg-violet-500",
    providerCount: 1800,
    subCategories: [
      { id: "temporary-event-staff", name: "Temporary Event Staff", icon: "👥", providerCount: 320 },
      { id: "waiter", name: "Waiter/Waitress", icon: "🍽️", providerCount: 280 },
      { id: "temporary-workers", name: "Temporary Workers", icon: "👷", providerCount: 350 },
      { id: "caterer", name: "Catering Services", icon: "🍴", providerCount: 280 },
      { id: "bartender", name: "Bartenders", icon: "🍸", providerCount: 180 },
      { id: "mc-host", name: "MC & Event Host", icon: "🎤", providerCount: 160 },
      { id: "ushers", name: "Ushers", icon: "🎀", providerCount: 230 },
      { id: "suya-man", name: "Suya Man", icon: "🍢", providerCount: 120 },
      { id: "hearth-bbq-specialist", name: "Hearth & BBQ Specialist", icon: "🔥", providerCount: 120 },
    ],
  },
  {
    id: "real-estate",
    name: "Real Estate & Property",
    description: "Sales, rentals, valuations, and property management",
    icon: "🏘️",
    image: "/placeholder.svg",
    color: "bg-emerald-600",
    providerCount: 1200,
    subCategories: [
      { id: "realtor", name: "Realtor / Estate Agent", icon: "🏡", providerCount: 320 },
      { id: "property-management", name: "Property Management", icon: "🏢", providerCount: 220 },
      { id: "valuation-surveyor", name: "Valuation & Surveying", icon: "📐", providerCount: 140 },
      { id: "rental-agent", name: "Rental Agent", icon: "🔑", providerCount: 260 },
      { id: "mortgage-broker", name: "Mortgage Broker", icon: "🏦", providerCount: 120 },
      { id: "home-staging", name: "Home Staging", icon: "🛋️", providerCount: 90 },
      { id: "commercial-leasing", name: "Commercial Leasing", icon: "🏬", providerCount: 110 },
    ],
  },
  {
    id: "manufacturing",
    name: "Manufacturing & Industrial",
    description: "Production, assembly, machining, and industrial trades",
    icon: "🏭",
    image: "/placeholder.svg",
    color: "bg-zinc-700",
    providerCount: 1600,
    subCategories: [
      { id: "cnc-machinist", name: "CNC Machinist", icon: "⚙️", providerCount: 180 },
      { id: "industrial-electrician", name: "Industrial Electrician", icon: "⚡", providerCount: 220 },
      { id: "boilermaker", name: "Boilermaker", icon: "🔥", providerCount: 90 },
      { id: "abattoir-worker", name: "Abattoir Worker", icon: "🥩", providerCount: 110 },
      { id: "meat-processor", name: "Meat Processor", icon: "🍖", providerCount: 90 },
      { id: "pipefitter", name: "Pipefitter / Steamfitter", icon: "🔧", providerCount: 140 },
      { id: "assembly-line", name: "Assembly Line Worker", icon: "🛠️", providerCount: 260 },
      { id: "quality-inspector", name: "Quality Inspector (QA/QC)", icon: "🔍", providerCount: 130 },
      { id: "hydraulic-tech", name: "Hydraulic Technician", icon: "💧", providerCount: 90 },
      { id: "instrumentation-tech", name: "Instrumentation Technician", icon: "🎛️", providerCount: 100 },
      { id: "packaging-operator", name: "Packaging Operator", icon: "📦", providerCount: 150 },
      { id: "process-operator", name: "Process Plant Operator", icon: "🏗️", providerCount: 120 },
      { id: "machinist", name: "Machinist", icon: "🛠️", providerCount: 120 },
      { id: "goldsmith-blacksmith", name: "Goldsmith & Blacksmith", icon: "🥇", providerCount: 120 },
      { id: "rig-technician", name: "Rig Technician", icon: "🛢️", providerCount: 120 },
      { id: "power-system-technician", name: "Power System Technician", icon: "🔌", providerCount: 120 },
      { id: "safety-officer", name: "Safety Officer", icon: "🦺", providerCount: 120 },
      { id: "tool-die-maker", name: "Tool & Die Maker", icon: "🧰", providerCount: 90 },
      { id: "sheet-metal-worker", name: "Sheet Metal Worker", icon: "📐", providerCount: 110 },
      { id: "foundry-caster", name: "Foundry Worker & Metal Caster", icon: "🔥", providerCount: 80 },
      { id: "heat-treatment-tech", name: "Heat Treatment Technician", icon: "♨️", providerCount: 60 },
      { id: "plastics-injection-molder", name: "Plastics & Injection Moulding Operator", icon: "🧪", providerCount: 90 },
      { id: "textile-machine-operator", name: "Textile Machine Operator", icon: "🧵", providerCount: 80 },
      { id: "maintenance-fitter", name: "Maintenance Fitter", icon: "🔩", providerCount: 130 },
      { id: "robotics-automation-tech", name: "Robotics & Automation Technician", icon: "🤖", providerCount: 70 },
    ],
  },
  {
    id: "energy-oil-gas",
    name: "Energy, Oil & Gas",
    description: "Upstream, midstream, downstream, and power services",
    icon: "⛽",
    image: "/placeholder.svg",
    color: "bg-orange-700",
    providerCount: 900,
    subCategories: [
      { id: "drilling-tech", name: "Drilling Technician", icon: "🛢️", providerCount: 90 },
      { id: "roughneck", name: "Roughneck / Roustabout", icon: "⛏️", providerCount: 120 },
      { id: "petroleum-engineer", name: "Petroleum Engineer", icon: "🧪", providerCount: 60 },
      { id: "power-lineman", name: "Power Lineman", icon: "🔌", providerCount: 110 },
      { id: "substation-tech", name: "Substation Technician", icon: "⚡", providerCount: 70 },
      { id: "wind-turbine-tech", name: "Wind Turbine Technician", icon: "🌬️", providerCount: 60 },
      { id: "solar-pv-installer", name: "Solar PV Installer", icon: "☀️", providerCount: 180 },
      { id: "gas-fitter", name: "Gas Fitter", icon: "🔥", providerCount: 90 },
      { id: "hse-officer", name: "HSE Officer", icon: "🦺", providerCount: 110 },
    ],
  },
  {
    id: "marine-shipping",
    name: "Marine & Shipping",
    description: "Vessels, ports, offshore, and maritime services",
    icon: "🚢",
    image: "/placeholder.svg",
    color: "bg-sky-700",
    providerCount: 520,
    subCategories: [
      { id: "seafarer", name: "Seafarer / Deckhand", icon: "⚓", providerCount: 120 },
      { id: "dockyard-worker", name: "Dockyard Worker", icon: "🚢", providerCount: 100 },
      { id: "longshoreman", name: "Longshoreman / Docker", icon: "⚓", providerCount: 80 },
      { id: "stevedore", name: "Stevedore", icon: "📦", providerCount: 70 },
      { id: "marine-engineer", name: "Marine Engineer", icon: "🛠️", providerCount: 80 },
      { id: "boat-mechanic", name: "Boat Mechanic", icon: "🛥️", providerCount: 90 },
      { id: "diver-commercial", name: "Commercial Diver", icon: "🤿", providerCount: 40 },
      { id: "port-operations", name: "Port Operations", icon: "🏗️", providerCount: 90 },
      { id: "shipping-freight", name: "Shipping & Freight Forwarding", icon: "📦", providerCount: 100 },
    ],
  },
  {
    id: "aviation-aerospace",
    name: "Aviation & Aerospace",
    description: "Aircraft, drones, ground handling, and aerospace",
    icon: "✈️",
    image: "/placeholder.svg",
    color: "bg-indigo-700",
    providerCount: 380,
    subCategories: [
      { id: "aircraft-mechanic", name: "Aircraft Maintenance Engineer", icon: "🔧", providerCount: 90 },
      { id: "avionics-tech", name: "Avionics Technician", icon: "📡", providerCount: 60 },
      { id: "pilot", name: "Pilot (Charter / Instruction)", icon: "🧑‍✈️", providerCount: 50 },
      { id: "cabin-crew", name: "Cabin Crew", icon: "👩‍✈️", providerCount: 80 },
      { id: "drone-operator", name: "Drone Operator / Pilot", icon: "🛸", providerCount: 100 },
      { id: "ground-handler", name: "Ground Handler", icon: "🛫", providerCount: 90 },
    ],
  },
  {
    id: "mining-quarry",
    name: "Mining & Quarrying",
    description: "Extraction, processing, and mine site services",
    icon: "⛏️",
    image: "/placeholder.svg",
    color: "bg-stone-700",
    providerCount: 320,
    subCategories: [
      { id: "miner-underground", name: "Underground Miner", icon: "⛏️", providerCount: 80 },
      { id: "haul-truck-driver", name: "Haul Truck Driver", icon: "🚛", providerCount: 110 },
      { id: "blasting-tech", name: "Blasting Technician", icon: "💥", providerCount: 50 },
      { id: "geologist", name: "Geologist / Assayer", icon: "🪨", providerCount: 40 },
      { id: "mine-electrician", name: "Mine Electrician", icon: "⚡", providerCount: 60 },
    ],
  },
  {
    id: "environmental",
    name: "Environmental Services",
    description: "Waste, recycling, water treatment, and sustainability",
    icon: "♻️",
    image: "/placeholder.svg",
    color: "bg-lime-700",
    providerCount: 600,
    subCategories: [
      { id: "waste-management", name: "Waste Management", icon: "🗑️", providerCount: 180 },
      { id: "recycling", name: "Recycling Services", icon: "♻️", providerCount: 140 },
      { id: "water-treatment", name: "Water Treatment", icon: "🚰", providerCount: 120 },
      { id: "sewage-septic", name: "Sewage & Septic", icon: "🚽", providerCount: 100 },
      { id: "environmental-consultant", name: "Environmental Consultant", icon: "🌍", providerCount: 60 },
    ],
  },
  {
    id: "hospitality-tourism",
    name: "Travel & Tourism",
    description: "Tour guides, travel planning, and hospitality staff",
    icon: "🧳",
    image: "/placeholder.svg",
    color: "bg-cyan-700",
    providerCount: 720,
    subCategories: [
      { id: "tour-guide", name: "Tour Guide", icon: "🗺️", providerCount: 180 },
      { id: "travel-agent", name: "Travel Agent", icon: "🎫", providerCount: 120 },
      { id: "concierge", name: "Concierge", icon: "🛎️", providerCount: 90 },
      { id: "housekeeping", name: "Hotel Housekeeping", icon: "🧹", providerCount: 180 },
      { id: "front-desk", name: "Front Desk / Receptionist", icon: "🖥️", providerCount: 150 },
    ],
  },
  {
    id: "retail-sales",
    name: "Retail & Sales",
    description: "In-store, field sales, merchandising, and e-commerce",
    icon: "🛍️",
    image: "/placeholder.svg",
    color: "bg-pink-700",
    providerCount: 1100,
    subCategories: [
      { id: "sales-associate", name: "Sales Associate", icon: "🛒", providerCount: 240 },
      { id: "cashier", name: "Cashier", icon: "💵", providerCount: 220 },
      { id: "field-sales", name: "Field Sales Rep", icon: "🚗", providerCount: 180 },
      { id: "merchandiser", name: "Merchandiser", icon: "📦", providerCount: 140 },
      { id: "ecommerce-manager", name: "E-commerce Manager", icon: "🛒", providerCount: 130 },
      { id: "store-manager", name: "Store Manager", icon: "🏪", providerCount: 120 },
      { id: "visual-merchandiser", name: "Visual Merchandiser", icon: "🎨", providerCount: 80 },
    ],
  },
  {
    id: "consulting-business",
    name: "Consulting & Business",
    description: "Management, HR, marketing, and business services",
    icon: "📈",
    image: "/placeholder.svg",
    color: "bg-slate-700",
    providerCount: 900,
    subCategories: [
      { id: "management-consultant", name: "Management Consultant", icon: "💼", providerCount: 140 },
      { id: "hr-consultant", name: "HR Consultant / Recruiter", icon: "👥", providerCount: 180 },
      { id: "marketing-consultant", name: "Marketing Consultant", icon: "📢", providerCount: 150 },
      { id: "business-analyst", name: "Business Analyst", icon: "📊", providerCount: 120 },
      { id: "project-manager", name: "Project Manager", icon: "📋", providerCount: 160 },
      { id: "virtual-assistant", name: "Virtual Assistant", icon: "🧑‍💻", providerCount: 200 },
    ],
  },
  {
    id: "translation-language",
    name: "Translation & Languages",
    description: "Translation, interpretation, transcription, and localization",
    icon: "🌐",
    image: "/placeholder.svg",
    color: "bg-teal-700",
    providerCount: 340,
    subCategories: [
      { id: "translator", name: "Translator", icon: "📝", providerCount: 140 },
      { id: "interpreter", name: "Interpreter (Live)", icon: "🗣️", providerCount: 90 },
      { id: "transcriptionist", name: "Transcriptionist", icon: "🎧", providerCount: 60 },
      { id: "localization", name: "Localization Specialist", icon: "🌍", providerCount: 50 },
    ],
  },
  {
    id: "writing-content",
    name: "Writing & Content",
    description: "Copywriting, editing, publishing, and content creation",
    icon: "✍️",
    image: "/placeholder.svg",
    color: "bg-fuchsia-700",
    providerCount: 620,
    subCategories: [
      { id: "copywriter", name: "Copywriter", icon: "🖊️", providerCount: 180 },
      { id: "editor-proofreader", name: "Editor / Proofreader", icon: "📚", providerCount: 120 },
      { id: "ghostwriter", name: "Ghostwriter", icon: "👻", providerCount: 80 },
      { id: "technical-writer", name: "Technical Writer", icon: "📄", providerCount: 90 },
      { id: "content-creator", name: "Social Content Creator", icon: "📱", providerCount: 150 },
    ],
  },
  {
    id: "sports-recreation",
    name: "Sports & Recreation",
    description: "Coaches, trainers, referees, and outdoor guides",
    icon: "🏅",
    image: "/placeholder.svg",
    color: "bg-yellow-700",
    providerCount: 520,
    subCategories: [
      { id: "sports-coach", name: "Sports Coach", icon: "🏀", providerCount: 180 },
      { id: "personal-trainer", name: "Personal Trainer", icon: "💪", providerCount: 160 },
      { id: "yoga-instructor", name: "Yoga Instructor", icon: "🧘", providerCount: 90 },
      { id: "swim-instructor", name: "Swim Instructor", icon: "🏊", providerCount: 70 },
      { id: "referee", name: "Referee / Umpire", icon: "🟨", providerCount: 60 },
      { id: "outdoor-guide", name: "Outdoor / Adventure Guide", icon: "🥾", providerCount: 60 },
    ],
  },
  {
    id: "public-safety",
    name: "Public Safety & Emergency",
    description: "First aid, safety training, and emergency response",
    icon: "🚑",
    image: "/placeholder.svg",
    color: "bg-red-700",
    providerCount: 280,
    subCategories: [
      { id: "first-aid-instructor", name: "First Aid Instructor", icon: "🩺", providerCount: 90 },
      { id: "lifeguard", name: "Lifeguard", icon: "🛟", providerCount: 80 },
      { id: "fire-safety", name: "Fire Safety Officer", icon: "🧯", providerCount: 60 },
      { id: "emt", name: "EMT / Paramedic Support", icon: "🚑", providerCount: 50 },
    ],
  },
  {
    id: "veterinary-pet",
    name: "Veterinary & Pet Care",
    description: "Vets, groomers, walkers, and pet trainers",
    icon: "🐾",
    image: "/placeholder.svg",
    color: "bg-amber-700",
    providerCount: 340,
    subCategories: [
      { id: "veterinarian", name: "Veterinarian", icon: "🐕‍🦺", providerCount: 90 },
      { id: "vet-tech", name: "Veterinary Technician", icon: "💉", providerCount: 60 },
      { id: "pet-groomer", name: "Pet Groomer", icon: "✂️", providerCount: 110 },
      { id: "dog-walker", name: "Dog Walker", icon: "🐕", providerCount: 100 },
      { id: "pet-trainer", name: "Pet Trainer", icon: "🐾", providerCount: 80 },
      { id: "pet-boarding", name: "Pet Boarding / Sitting", icon: "🏠", providerCount: 70 },
    ],
  },
  {
    id: "heavy-equipment",
    name: "Heavy Equipment & Operators",
    description: "Certified operators and technicians for earthmoving, lifting, and paving machinery",
    icon: "🚜",
    image: "/images/categories/heavy-equipment.jpg",
    color: "bg-amber-700",
    providerCount: 1800,
    subCategories: [
      { id: "grader-operator", name: "Grader Operator", icon: "🛣️", providerCount: 120 },
      { id: "motor-grader-operator", name: "Motor Grader Operator", icon: "🛠️", providerCount: 90 },
      { id: "bulldozer-operator", name: "Bulldozer Operator", icon: "🚜", providerCount: 140 },
      { id: "excavator-operator", name: "Excavator Operator", icon: "🏗️", providerCount: 180 },
      { id: "backhoe-operator", name: "Backhoe Operator", icon: "🚧", providerCount: 130 },
      { id: "loader-operator", name: "Loader Operator", icon: "🚛", providerCount: 140 },
      { id: "dumper-operator", name: "Dumper Truck Operator", icon: "🛻", providerCount: 120 },
      { id: "crane-hoisting-operator", name: "Crane & Hoisting Operator", icon: "🏗️", providerCount: 110 },
      { id: "telehandler-operator", name: "Telehandler Operator", icon: "🔧", providerCount: 80 },
      { id: "forklift-operator", name: "Forklift Operator", icon: "🚜", providerCount: 160 },
      { id: "compactor-operator", name: "Compactor / Roller Operator", icon: "🛞", providerCount: 90 },
      { id: "asphalt-paver-operator", name: "Asphalt Paver Operator", icon: "🛣️", providerCount: 85 },
      { id: "heavy-equipment-hire", name: "Heavy Equipment Hire", icon: "📦", providerCount: 95 },
    ],
  },
  {
    id: "inspection-testing",
    name: "Inspection, Testing & Certification",
    description: "Non-destructive testing, integrity inspection, calibration, and compliance certification",
    icon: "🔬",
    image: "/placeholder.svg",
    color: "bg-sky-700",
    providerCount: 1200,
    subCategories: [
      { id: "ndt-technician", name: "Non-Destructive Testing (NDT) Technician", icon: "🔬", providerCount: 160 },
      { id: "ndt-level-ii-iii", name: "NDT Level II / III Inspector", icon: "🎖️", providerCount: 90 },
      { id: "ultrasonic-testing", name: "Ultrasonic Testing (UT)", icon: "📡", providerCount: 110 },
      { id: "radiographic-testing", name: "Radiographic Testing (RT)", icon: "☢️", providerCount: 90 },
      { id: "magnetic-particle-testing", name: "Magnetic Particle Testing (MPI)", icon: "🧲", providerCount: 85 },
      { id: "dye-penetrant-testing", name: "Dye Penetrant Testing (PT)", icon: "🧴", providerCount: 80 },
      { id: "eddy-current-testing", name: "Eddy Current Testing (ET)", icon: "🌀", providerCount: 60 },
      { id: "visual-weld-inspector", name: "Visual & Welding Inspector (CSWIP/CWI)", icon: "👁️", providerCount: 120 },
      { id: "pipeline-integrity-inspector", name: "Pipeline Integrity Inspector", icon: "🛢️", providerCount: 95 },
      { id: "tank-vessel-inspector", name: "Tank & Pressure Vessel Inspector", icon: "🛞", providerCount: 80 },
      { id: "coating-inspector", name: "Coating & Painting Inspector (NACE)", icon: "🎨", providerCount: 75 },
      { id: "lifting-equipment-inspector", name: "Lifting Equipment & Crane Inspector", icon: "🏗️", providerCount: 70 },
      { id: "electrical-safety-inspector", name: "Electrical Safety Inspector", icon: "⚡", providerCount: 85 },
      { id: "fire-safety-inspector", name: "Fire Safety Inspector", icon: "🧯", providerCount: 75 },
      { id: "calibration-technician", name: "Calibration Technician", icon: "🎛️", providerCount: 70 },
      { id: "metrology-technician", name: "Metrology Technician", icon: "📏", providerCount: 55 },
      { id: "laboratory-materials-testing", name: "Materials & Laboratory Testing", icon: "🧪", providerCount: 90 },
      { id: "soil-concrete-testing", name: "Soil & Concrete Testing", icon: "🧱", providerCount: 85 },
      { id: "hse-auditor", name: "HSE Auditor & Compliance Officer", icon: "🦺", providerCount: 95 },
      { id: "iso-quality-auditor", name: "ISO / Quality Systems Auditor", icon: "📋", providerCount: 70 },
      { id: "drone-inspection", name: "Drone & Rope Access Inspection", icon: "🚁", providerCount: 60 },
    ],
  },
  {
    id: "surface-treatment",
    name: "Surface Treatment & Coatings",
    description: "Sandblasting, industrial painting, galvanising, and protective coating specialists",
    icon: "🪣",
    image: "/placeholder.svg",
    color: "bg-orange-800",
    providerCount: 950,
    subCategories: [
      { id: "sandblaster", name: "Sandblaster / Abrasive Blaster", icon: "💨", providerCount: 140 },
      { id: "shot-blasting", name: "Shot & Bead Blasting", icon: "⚪", providerCount: 90 },
      { id: "hydro-blasting", name: "Hydro / Water Jet Blasting", icon: "💦", providerCount: 80 },
      { id: "dry-ice-blasting", name: "Dry Ice Blasting", icon: "🧊", providerCount: 45 },
      { id: "industrial-painter", name: "Industrial & Protective Painter", icon: "🖌️", providerCount: 130 },
      { id: "spray-painter", name: "Spray Painter (Airless)", icon: "🎨", providerCount: 110 },
      { id: "powder-coating", name: "Powder Coating Specialist", icon: "✨", providerCount: 95 },
      { id: "galvanising", name: "Galvanising & Zinc Coating", icon: "🔩", providerCount: 70 },
      { id: "electroplating", name: "Electroplating & Anodising", icon: "⚗️", providerCount: 60 },
      { id: "thermal-spray-coating", name: "Thermal Spray Coating", icon: "🔥", providerCount: 50 },
      { id: "fireproofing-coating", name: "Fireproofing & Intumescent Coating", icon: "🧯", providerCount: 55 },
      { id: "corrosion-protection", name: "Corrosion Protection Specialist", icon: "🛡️", providerCount: 75 },
      { id: "pipe-lining-coating", name: "Pipe Lining & Internal Coating", icon: "🛢️", providerCount: 65 },
      { id: "surface-preparation", name: "Surface Preparation & Rust Removal", icon: "🧽", providerCount: 100 },
      { id: "pressure-washing-industrial", name: "Industrial Pressure Washing", icon: "🚿", providerCount: 90 },
    ],
  },
];

export const featuredCategories = categories.slice(0, 8);
